import {useState} from "react";
import {useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Button, Spin} from "antd";
import {useTranslation} from "react-i18next";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Document,
    StyleSheet,
    PDFDownloadLink,
    Font,
} from "@react-pdf/renderer";
import 'moment/locale/es';
import source1Font from "../../../assets/fonts/futura-book.otf";
import source2Font from "../../../assets/fonts/futura-medium.woff";
import source3Font from "../../../assets/fonts/futura-bold.woff";
import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import {useLocation} from "react-router-dom";
import _ from "lodash";
import CervoPartPdf from "./pdf/cervo.pdf";

Font.register({
    family: 'Futura', fonts: [
        {src: source1Font},
        {src: source2Font, fontWeight: 500},
        {src: source3Font, fontWeight: 700},
    ]
});
Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
    page: {
        paddingBottom: 45,
        backgroundColor: "#ffffff",
    },
    pageRes: {
        paddingBottom: 45,
        backgroundColor: "#ffffff",
    },
    headerSection: {
        flexDirection: "row",
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {margin: "auto", flexDirection: "row"},
    tableCol: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCell: {
        margin: "auto",
        marginTop: 8,
        marginBottom: 8,
        fontSize: 10
    },
});

const stylesPdf = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        fontFamily: 'Futura',
        fontSize: 14
    },
    titleOne: {
        color: '#1C2E36',
        textAlign: 'center',
        marginTop: 12,
        fontSize: 16,
        fontWeight: 700,
        lineHeight: "175%"
    },
    subtitle: {
        color: '#1C2E36',
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 400
    },
    spacetext: {
        marginTop: 8,
        marginBottom: 0
    },
    spacetextxs: {
        marginTop: 4,
        marginBottom: 0
    },
    step: {
        color: '#1C2E36',
        textAlign: 'justify',
        marginTop: 8,
        marginLeft: 24,
        marginRight: 24,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.5
    },
    headerTable: {
        marginTop: 16,
        marginLeft: 24,
        marginRight: 24,
        padding: 8,
        backgroundColor: "#FFB81C",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderColor: "#a5adbb",
        borderTopWidth: 1,
        borderRightWidth: 1,
        borderLeftWidth: 1,
    },
    h1HeaderTable: {
        fontSize: 12,
        fontWeight: 500,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: "167%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    columnWidth60: {
        width: "60%",
    },
    columnWidth40: {
        width: "40%",
    },
    rowheadercolor: {
        display: "table",
        width: "auto",
        marginRight: 8,
        marginLeft: 8,
        borderWidth: 1, borderColor: "#FFB81C", padding: 0,
        borderTopRightRadius: 30, borderTopLeftRadius: 30
    },

    rowheader: {
        display: "table",
        width: "auto",
        borderWidth: 0,
        marginRight: 8,
        marginLeft: 8
    },
    rowTable: {
        marginLeft: 24,
        marginRight: 24,
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8
    },
    colTable: {
        width: "50%",
        padding: 8,
        backgroundColor: "#ffffff",
        fontSize: 12,
        marginLeft: 0,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: 1,
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderTopWidth: 1
    },
    colTableBottomL: {
        borderBottomLeftRadius: 8,
    },
    colTableBottomR: {
        borderBottomRightRadius: 8
    },
    colBorderCenter: {
        borderLeftWidth: 1,
        borderColor: "#a5adbb"
    },
    footer: {
        margin: 16,
        fontSize: 9,
        textAlign: "center",
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
    },
    footerFirstPage: {
        marginTop: 16,
        marginRight: 16,
        marginBottom: 56,
        marginLeft: 16,
        fontSize: 9,
        textAlign: "center"
    },
    imagelogoheader: {
        width: 90,
    },
    imageLogoCenter: {
        width: 172,
        marginBottom: 16
    },
    imageReportCenter: {
        width: 154,
        height: 154,
        marginBottom: 24
    },
    titlePortada: {
        fontSize: 20,
        marginBottom: 8
    },
    subtitlePortada: {
        fontSize: 20,
        fontWeight: 700,
        textTransform: "uppercase"
    },
    numberPage: {
        position: 'absolute',
        bottom: 24,
        right: 24,
        textAlign: 'right',
        color: '#1C2E36',
        fontSize: 10
    },
    link: {
        color: "#20388f"
    },
    pageBackground: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 0,
    },
    pageBackgroundFooter: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 0,
        height: 40
    },
    lineText: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center"
    },
    lineText2: {

        display: "flex",
        flexDirection: "row",
    },

    strongText: {
        fontWeight: 500
    },
    strongText2: {
        fontSize: 11,
        fontWeight: 500
    },
    strongText3: {
        fontSize: 14,
        fontWeight: 500
    },
    paddingTextCenter: {
        paddingTop: 6,
        fontSize: 11
    },
    marginT4: {
        marginTop: 4
    }
});
/*

studentProfile={studentProfile}
                        answers={answers}
                        studentArea={studentArea}
 */
/*   */
const MyDoc = ({t, props, i18n, studentProfile, answers,studentArea}) => {


    const getResponse = (array, code) => {
        let mResult = _.filter(array, function (o) {
            return o.assessment.order === code
        });

        if (mResult && mResult.length > 0) {
            if (mResult[0].response) {
                return mResult[0]?.response?.question
            } else {
                if (mResult[0].degree) {
                    return mResult[0]?.degree?.family + " " + mResult[0]?.degree?.title
                }
            }

        } else {
            return t("informes.pendiente.miproyecto")
        }
    }

    return <Document>

        <CervoPartPdf
            t={t}
            studentHistory={props.studentHistory}
            i18n={i18n}
            studentProfile={studentProfile}
            answers={answers}
            studentArea={studentArea}
        />
    </Document>
};

function InformeCervoPDF(props) {
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {query, search} = useLocation();
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");





    const callToLink = (url, blob) => {
        if (url && blob) {
            const href = window.URL.createObjectURL(blob);
            document.location.replace(href);
        }

    }


    return (
        <>


            <PDFDownloadLink
                document={
                    <MyDoc
                        t={t}
                        props={props}
                        i18n={i18n}
                        studentProfile={props.studentProfile}
                        answers={props.answers}
                        studentArea={props.studentArea}
                    />
                }
                fileName={"informeCervo_" + props.studentProfile.name + "-" +  props.answers[0].year ?? 22 + ".pdf"
                }
            >
                {({blob, url, loading, error}) => (loading ? <>
                    {!props.forDownload ? <>{t("generandoInforme")}{" "}{t("datos.informeII")}</> : <div style={{position: "absolute", top: "50%", left: "40%"}}>

                        <Spin size="large" />
                        <span style={{fontSize: 20}}>

                                {t("generandoInforme")}{" "}{t("datos.informeII")}
                            </span>
                    </div>}
                </> : <>
                    {!props.forDownload ? <Button
                            className="primaryButton" type="primary" icon={<DownloadOutlined/>}>
                            {t("descargarinforme")}{" "}{t("datos.informeII")}
                        </Button> :
                        <iframe src={url} style={{ width: "100%", height: "100%" }} />
                        //callToLink(url, blob)

                    }
                </>)}
            </PDFDownloadLink>
        </>
    );
}

export default withTranslation()(InformeCervoPDF);
